import { ICampaign, IScenarioState } from "./Scenario";
import { Card, IStarterDeck, ICardReference, ICard, CardType, ApplicationException, CardSubType } from "./Card";
import { Assert } from "./Assert";
import { CardUtil } from "./CardUtil";

export interface IModuleLoader {
    loadModule():ICampaignModule;
}
export interface ICampaignModule {
    cards: ICard[];
    starterDecks: IStarterDeck[];
    campaign: ICampaign;
}
export class Stock {
    static createCardReferences(pack: number, packNumbers: number[]): ICardReference[] {
        return packNumbers.map(n => ({ pack: pack, packNumber: n } as ICardReference));
    }
    static createStarterDeck(investigator: ICard): ICard[] {
        const starterDeck = Stock.starterDecks.filter(d => d.investigator.pack === investigator.pack && d.investigator.packNumber === investigator.packNumber)[0];
        return starterDeck.deck.map(r => Stock.getCard(r));
    }

    static getCardsOfType(cardType: CardType, set: string): ICard[] {
        //filter out correct cards and return a clone of the card
        return Stock.cards.filter((card: Card) => { return card.type === cardType && (!set || card.set === set) })
            .map(c => ({ ...c }));
    }
    static getCard(reference: ICardReference): ICard {
        const card = Stock.cards.filter(c => c.pack === reference.pack && c.packNumber === reference.packNumber)[0];
        return { ...card };
    }
    static getAllCards(horizontal: boolean):ICard[] {
        return CardUtil.distinct(Stock.cards).filter(c => {
            return horizontal === (c.type === CardType.Act || c.type === CardType.Agenda || c.type === CardType.Investigator);
        }).map(c=>({...c}));
    }
    static getCardsFromSet(pack: number, sets: string[]): ICard[] {
        return Stock.cards.filter((card: Card) => {
            if (card.pack !== pack)
                return false;
            return sets.some(s => { return card.set === s; });
        }).map(c => ({ ...c }));
    }
    static getAllPlayerCardsForDeckCustomization(): ICard[] {
        return CardUtil.distinct(Stock.cards).filter((card: ICard) => {
            //ignore investigator cards
            if (card.type === CardType.Investigator) return false;
            switch (card.subType) {
                case CardSubType.Neutral:
                case CardSubType.Guardian:
                case CardSubType.Seeker:
                case CardSubType.Rouge:
                case CardSubType.Mystic:
                case CardSubType.Survivor:
                    return true;
                default:
                    return false;
            }
        }).map(c => ({ ...c }));
    }

    static getRandomCardOfType(cardType: CardType, subType: CardSubType): ICard {
        const cards = Stock.cards.filter(c => {
            if (c.type !== cardType) return false;
            if (c.subType !== subType) return false;
            return true;
        });
        const card = CardUtil.randomCard(cards);
        return ({ ...card });
    }
    private static starterDecks: IStarterDeck[] = [];
    private static cards: ICard[] = [];
    static campaigns: ICampaign[] = [];

    static registerModule(moduleLoader: IModuleLoader): ICampaign {
        const module = moduleLoader.loadModule();
        //skip loading if already loaded
        const existingCampaigns = this.campaigns.filter(c => c.name === module.campaign.name);
        if (existingCampaigns && existingCampaigns.length) {
            return existingCampaigns[0];
        }
        Stock.load(module);
        return module.campaign;
    }
    static load(module: ICampaignModule): void {
        if (this.campaigns.some(c => c.name === module.campaign.name)) {
            throw new ApplicationException(`A campaign named ${module.campaign.name} is already loaded`);
        }
        this.campaigns.push(module.campaign);
        this.cards = this.cards.concat(module.cards);
        this.starterDecks = this.starterDecks.concat(module.starterDecks);

    }
    static assertScenarioState(state: IScenarioState,acts: number,agenda: number,activeLocations: number,inactiveLocations: number,encounterDeck: number,extraDecks: number[]): void {
        Assert.exists(state.scenarioCard, "Scenario card");
        Assert.areEqual(acts, state.actState.deck.cards.length, "Act cards");
        Assert.areEqual(agenda, state.agendaState.deck.cards.length, "Agenda cards");
        Assert.areEqual(activeLocations + inactiveLocations, state.locations.length, "Locations");
        Assert.areEqual(activeLocations, state.locations.filter(l => !l.inactive).length, "Locations");
        Assert.areEqual(inactiveLocations, state.locations.filter(l => l.inactive).length, "Locations");
        Assert.areEqual(encounterDeck, state.encounterDeck.cards.length, "Encounter deck");
        Assert.areEqual(extraDecks.length, state.extraDecks.length, "Number of ExtraDecks");
        for (let i = 0; i < extraDecks.length; i++) {
            Assert.areEqual(extraDecks[i], state.extraDecks[i].cards.length, `ExtraDeck[${i}]`);
        }
      
    }

}
//}
